<script>
import { editCategories } from "../../../js/services/editor/website";
import ModalComponent from '../../general/Modal';

export default {
  name: "MoveCategory",
  components: {ModalComponent},
  props: ['show', 'config', 'categories'],
  data() {
    return {
      websiteCategoryList: [],
    };
  },
  watch: {
    show: function (val) {
      if (val)
        this.$refs.moveFile.open();
      else
        this.$refs.moveFile.close();
    },
    config: function(config) {
      if (config && Object.values(config).length) {
        this.updateCategoryList();
      }
    },
  },
  methods: {
    updateCategoryList() {
      let website = this.config;
      this.websiteCategoryList = website.categories.map(category => category.id);
    },

    openNewCategory() {
      this.closeMoveCategory();
      this.$emit('openNewCategory');
    },

    closeMoveCategory() {
      this.categorySelected = false;
      this.$store
        .dispatch('dashboard/moveCategory', {show: false});
    },

    openCategorySelected(category) {
      if (category && this.websiteCategoryList.includes(category.id))
        this.websiteCategoryList = this.websiteCategoryList.filter(value => value !== category.id);
      else
        this.websiteCategoryList.push(category.id);
    },

    confirmMoveCategory() {
      var website = {
        encrypted_id: this.config.encrypted_id,
        categories: this.websiteCategoryList
      };

      this.$loading.show();

      editCategories(website)
        .then(({ data }) => {
          if (data.data.error && !data.data.success)
            this.$snotify.error(this.$t('ct-website-categories-save-error'));
          else {
            this.$snotify.success(this.$t('ct-website-categories-save-success'));

            this.closeMoveCategory();
            this.$emit('updateWebsites');
          }
        })
        .catch(() => {
          this.$snotify.error(this.$t('ct-website-categories-save-error'));
        })
        .finally(() => this.$loading.hide());
    },
  }
};
</script>

<template>
  <modal-component
    ref="moveFile"
    :show="show" :title="$t('ct-move-category')" width="32%"
    min-width="400px" header="true">
    <div slot="body" class="files-move-body">
      <div class="files-move-container">
        <div class="files-move-container-navbar">
          <ul class="files-move-list-navbar">
            <li>
              <i class="icon ct-icon-folder-open"/>
              <span>{{ $t('ct-categories-all') }}</span>
            </li>
          </ul>
        </div>

        <template v-if="categories && categories.length > 0">
          <div class="files-move-container-choose-folder">
            <ul class="files-move-list-choose-folder">
              <li
                v-for="(category, index) in categories" :key="index"
                @click.prevent="openCategorySelected(category)">
                <div>
                  <i class="icon ct-icon-folder"/>
                  <span>{{ category.name }}</span>
                </div>
                <div
                  v-if="websiteCategoryList.includes(category.id)"
                  :class="{ 'selected' : websiteCategoryList.includes(category.id)}" class="options"
                  @click.prevent="openCategorySelected(category)">
                  <font-awesome-icon :icon="['fas', 'check']"/>
                </div>
              </li>
            </ul>
          </div>
        </template>
      </div>
    </div>

    <div slot="footer" class="files-move-footer justify-content-between">
      <button
        class="btn btn-y-lg btn-new-directory"
        @click.prevent="openNewCategory()">
        <i class="icon ct-icon-folder-plus mr-2"/> {{ $t('ct-category-new') }}
      </button>
      <div>
        <button
          class="btn btn-y-lg btn-light"
          @click.prevent="closeMoveCategory()"
        >{{ $t('ct-cancel') }}</button>

        <button
          class="btn btn-y-lg btn-success"
          @click.prevent="confirmMoveCategory()"
        ><i class="svg-icon svgi-save"/>{{ $t('ct-save') }}
        </button>
      </div>
    </div>
  </modal-component>
</template>



// WEBPACK FOOTER //
// src/components/dashboard/modals/MoveCategory.vue